import { render, staticRenderFns } from "./answerSheet.vue?vue&type=template&id=6c1aba5a&scoped=true&"
import script from "./answerSheet.vue?vue&type=script&lang=js&"
export * from "./answerSheet.vue?vue&type=script&lang=js&"
import style0 from "./answerSheet.vue?vue&type=style&index=0&id=6c1aba5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1aba5a",
  null
  
)

export default component.exports